<template>
  <mdb-container :class="currentGroup && $route.params.groupId ? '' : 'gp-has-header'">
    <banner-small :group="currentGroup" title="Card Page" v-if="currentGroup && $route.params.groupId"/>
    <div class="text-left" v-if="showMain && details">
      <mdb-btn @click="goBack" icon="arrow-left" rounded size="sm" v-if="!editMode">Card
        List
      </mdb-btn>
      <mdb-card class="mb-4">
        <mdb-card-header class="secondary-color text-white">
          <h5>Card Page</h5>
        </mdb-card-header>
        <mdb-card-body>
          <mdb-input :disabled="!editMode" label="Page Name" type="text" v-model="details.name"/>
          <mdb-input :disabled="urlDisabled" id="url-link" label="Document Link" type="text" v-model="linkToPage">
            <span class="input-group-text md-addon" slot="append">
              <mdb-btn @click="copyClipboard" icon="copy" rounded size="sm">Copy to Clipboard</mdb-btn>
              <mdb-badge v-if="urlCopied">Copied</mdb-badge>
            </span>
          </mdb-input>

          <mdb-input :disabled="!editMode" id="is-public-checkbox" label="Publicly Visible?" type="checkbox"
                     v-model="details.isPublic"/>
          <editor v-if="editMode" :group="currentGroup" :field="details.pageText" @input="details.pageText = $event" label="Text"/>

          <mdb-btn @click="editMode=true" icon="pencil" rounded size="sm" v-if="!editMode">Edit</mdb-btn>
          <mdb-btn :disabled="!maySave" @click="savePage" color="success" icon="save" rounded size="sm" v-if="editMode">
            Save
          </mdb-btn>
          <mdb-btn @click="editMode=false" color="danger" icon="minus-circle" rounded size="sm" v-if="editMode">Cancel
          </mdb-btn>
        </mdb-card-body>
      </mdb-card>

      <mdb-card class="mb-4">
        <mdb-card-header class="secondary-color text-white">
          <h4>Cards</h4>
        </mdb-card-header>
        <mdb-card-body>
          <mdb-btn @click="addCard" icon="plus-circle" rounded size="sm" v-if="!editMode">Add Card</mdb-btn>
          <mdb-list-group>
            <mdb-list-group-item v-bind:key="i" v-for="(card,i) in cards">
              {{ card.name }}
              <div style="float:right;">
                <mdb-btn @click="editCard(card)" floating icon="pencil" size="sm" tag="a"></mdb-btn>
              </div>
            </mdb-list-group-item>
          </mdb-list-group>
        </mdb-card-body>
      </mdb-card>
    </div>

    <div class="text-left" v-if="showCard">
      <mdb-btn @click="cancelCard" icon="arrow-left" rounded size="sm">Back</mdb-btn>
      <mdb-card class="mb-4">
        <mdb-card-header class="secondary-color text-white">
          <h5>Card</h5>
        </mdb-card-header>
        <mdb-card-body>
          <mdb-input label="Name" type="text" v-model="editing.name"/>
          <mdb-row>
            <mdb-col md="6">
              <div class="md-form">
                <div>
                  <datetime :auto="true"
                            :format="userDetails.dateFormat"
                            :valueZone="userDetails.timezone.ID"
                            :week-start="userDetails.mondayFirst ? 1 : 7"
                            :zone="userDetails.timezone.ID"
                            id="from-input"
                            v-model="editing.startDate"></datetime>
                  <label class="active mr-5">Visible From</label>
                  <mdb-btn @click="editing.startDate=null" rounded size="sm">Clear Date</mdb-btn>
                </div>
              </div>
            </mdb-col>
            <mdb-col md="6">
              <div class="md-form">
                <div>
                  <datetime :auto="true"
                            :format="userDetails.dateFormat"
                            :valueZone="userDetails.timezone.ID"
                            :week-start="userDetails.mondayFirst ? 1 : 7"
                            :zone="userDetails.timezone.ID"
                            id="through-input"
                            v-model="editing.endDate"></datetime>
                  <label class="active mr-5">Visible Through</label>
                  <mdb-btn @click="editing.endDate=null" rounded size="sm">Clear Date</mdb-btn>
                </div>
              </div>
            </mdb-col>
          </mdb-row>
          <mdb-row>
            <mdb-col class="text-center" md="12">
              <div>
                <img :src="editing.topImage" style="max-width:300px" v-if="editing.topImage"/>
              </div>
              <div>
                <mdb-btn @click="showTopImageSelector=true" icon="photo" rounded size="sm">
                  {{ editing.topImage ? 'Change' : 'Select' }} Top Image
                </mdb-btn>
              </div>
            </mdb-col>
          </mdb-row>
          <mdb-row>
            <mdb-col class="text-center" md="12">
              <editor label="Card Body"
                      :field="editing.pageText" @input="editing.pageText = $event"
                      :group="currentGroup"/>

              <mdb-btn :disabled="!maySaveCard" @click="saveCard" color="success" icon="save" rounded size="sm">
                Save
              </mdb-btn>
            </mdb-col>
          </mdb-row>
        </mdb-card-body>
      </mdb-card>
    </div>
    <mdb-modal @close="showTopImageSelector = false" v-if="showTopImageSelector"  class="gp-z-2000">
      <mdb-modal-header :close="true" center class="secondary-color text-white">Select an Image</mdb-modal-header>
      <mdb-modal-body>
        <image-selector v-if="$route.params.groupId" :group="currentGroup" @topImageSelected="topImageSelected" emitOnSelection="topImageSelected"/>
        <system-image-selector v-if="!$route.params.groupId" @topImageSelected="topImageSelected" emitOnSelection="topImageSelected"/>
      </mdb-modal-body>
    </mdb-modal>

    <mdb-modal :show="showImageSelector" @close="showImageSelector = false">
      <mdb-modal-header :close="true" center class="secondary-color text-white">Select an Image</mdb-modal-header>
      <mdb-modal-body>
        <image-selector :group="currentGroup" @imageSelected="imageSelected" emitOnSelection="imageSelected"/>
      </mdb-modal-body>
    </mdb-modal>

  </mdb-container>

</template>
<script>
import api from '../../services/groupsPlaceApi.js'
import {Datetime} from 'vue-datetime'
import bannerSmall from "../group/BannerSmall";
import {
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardHeader,
  mdbCol,
  mdbContainer,
  mdbInput,
  mdbListGroup,
  mdbListGroupItem,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbRow
} from 'mdbvue';
import Vue from "vue";
import imageSelector from '../group/ImageSelector'
import systemImageSelector from "./SystemImageSelector";
import Editor from "../group/Editor";

export default {
  name: "system-card",
  display: "Card Page",
  order: 1,
  components: {
    mdbContainer,
    mdbInput,
    mdbBtn,
    mdbCard,
    mdbCardHeader,
    mdbCardBody,
    mdbListGroup,
    mdbListGroupItem,
    mdbRow,
    mdbCol,
    mdbModal,
    mdbModalBody,
    mdbModalHeader,
    Datetime,
    bannerSmall,
    imageSelector,
    systemImageSelector,
    Editor
  },
  computed: {
    userDetails: function () {
      return this.$store.state.userDetails
    },
    maySave: function () {
      if (this.details.name) return true
      else return false
    },
    maySaveCard: function () {
      if (this.editing.name && this.editing.pageText) return true
      else return false
    },
    currentGroup: function () {
      return this.$store.state.currentGroup
    },
    linkToPage: function () {
      let url = window.location.origin
      if (this.$route.params.groupId) {
        url += "/group/" + this.currentGroup.vanityPath + "/cards/" + this.details.urlName
      } else {
        url += "/cards/" + this.details.urlName
      }
      return url
    }
  },
  data() {
    return {
      details: null,
      cards: [],
      editMode: false,
      showMain: true,
      showCard: false,
      currentCard: null,
      editing: null,
      showImageSelector: false,
      showTopImageSelector: false,
      imageCallback: null,
      urlCopied: false,
      urlDisabled: true,
      editorConfig: {
        browser_spellcheck: true,
        branding: false,
        plugins: ["image", "link", "code", "paste", "table", "lists"],
        toolbar: ["undo redo cut copy paste bold italic underline numlist bullist fontsizeselect | alignleft alignright aligncenter | styleselect | image link unlink code "],
        image_advtab: true,
        style_formats_merge: true,
        paste_as_text: true,
        relative_urls: false,
        remove_script_host: false,
        height: 400,
        style_formats: [{
          title: 'Image Left',
          selector: 'img',
          styles: {
            'float': 'left',
            'margin': '0 10px 0 10px'
          }
        },
          {
            title: 'Image Right',
            selector: 'img',
            styles: {
              'float': 'right',
              'margin': '0 0 10px 10px'
            }
          },
          {
            title: 'GP Heading',
            block: 'div',
            classes: 'tile_title'
          }
        ]
      },

    }
  },
  async mounted() {
    document.title = "Card Page"
    let url = "/card/get/" + this.$route.params.id
    if (this.$route.params.groupId) {
      await api.groupBasics(this.$route.params.groupId, "member")
      url += "?group=" + this.$route.params.groupId
      this.editorConfig.paste_data_images = false;
      this.editorConfig.file_picker_callback = this.myFileBrowser;
    } else {
      this.editorConfig.images_upload_handler = this.uploadImage;
      this.editorConfig.paste_data_images = true;
    }
    await this.$store.dispatch("setExecuting", true)
    api.get(url).then(
      (details) => {
        this.details = details.data.page
        this.cards = details.data.cards
      },
      (error) => {
        if (error.response.status == 404) this.$router.push("/404")
        else if (error.response.status == 403) this.$router.push("/403")
        this.$notify.error({message: "Error getting card page."})
      }).then(() => {
      this.$store.dispatch("setExecuting", false)
    })
  },
  methods: {
    goBack: function () {
      if (this.$route.params.groupId) this.$router.push('/group/' + this.currentGroup.vanityPath + '/card-pages')
      else this.$router.push('/admin/card-pages')
    },
    imageSelected: function (image) {
      this.showImageSelector = false
      let el = document.getElementsByClassName("tox-dialog-wrap")
      el[0].setAttribute("style", "display:block")
      Vue.nextTick().then(() => {
        this.imageCallback(image.url, {width: "33%", height: ""})
      })
    },
    topImageSelected: function (image) {
      this.showTopImageSelector = false
      this.editing.topImageId = image.id
      this.editing.topImage = image.url
    },
    myFileBrowser: function (callBack, value, meta) {
      let el = document.getElementsByClassName("tox-dialog-wrap")
      el[0].setAttribute("style", "display:none")
      Vue.nextTick().then(() => {
        this.showImageSelector = true
        this.imageCallback = callBack
      })
    },
    saveCard: function () {
      this.$store.dispatch("setExecuting", true)
      api.post("/card/saveCard/" + this.details.id, this.editing).then(
        (results) => {
          if (this.editing.id) Object.assign(this.currentCard, results.data)
          else (this.cards.unshift(results.data))
          this.showCard = false
          this.showMain = true
          this.editing = null
        },
        (error) => {
          this.$notify.error({message: "Error saving card."})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    uploadImage: function (img, success, failure) {
      let ret = {location: null}
      api.postImage("/admin/newImage/", img.blob()).then(
        (results) => {
          success(results.data)
        },
        (error) => {
          failure(error.response.data)
        });
    },
    addCard: function () {
      this.editing = {
        id: null,
        name: "",
        pageText: "",
        startDate: null,
        endDate: null,
        topImage: null,
        topImageId: null
      };
      this.showMain = false
      this.showCard = true
    },
    cancelCard: function () {
      this.showMain = true
      this.showCard = false
      this.currentCard = null
    },
    savePage: function () {
      this.$store.dispatch("setExecuting", true)
      api.post("/card/savePage", this.details).then(
        (details) => {
          this.details = details.data
          this.editMode = false
        },
        (error) => {
          this.$notify.error({message: "Error getting card page."})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    viewCard: function (doc) {
      alert("Getting to it.")
    },
    editCard: function (card) {
      this.currentCard = card;
      this.editing = JSON.parse(JSON.stringify(card));
      this.showMain = false;
      this.showCard = true;
    },
    copyClipboard: function () {
      let el = document.getElementById("url-link")
      if (!el) return
      el.removeAttribute("disabled")
      el.select()
      el.setSelectionRange(0, 99999);
      document.execCommand("copy")
      this.urlCopied = true
      el.setAttribute("disabled", "disabled")
    }
  }
};
</script>
<style lang="scss">
@import '~vue-datetime/dist/vue-datetime.min';
</style>
